/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { TENANTS } from "../../../constants"
import { getCivilStatusLabel } from "../../ClientPage/service/ClientPageServices"
import Bloc from "./Bloc"
import Field from "./Field"
import React from "react"

export default function CompanyBloc({ tunnelData, configuration, values }) {
  const { company } = configuration
  const { tenant } = tunnelData

  const getBlocTitleByTenant = () => {
    if (tenant === TENANTS.BPLS) return "firm_bloc_title"
    return "Company"
  }

  return (
    <Bloc hide={!company} name={getBlocTitleByTenant()}>
      <Field hide={!company?.includes("name")} name={"Company name"} value={values.company.name} />
      <Field hide={!company?.includes("siret")} name={"Company siret"} value={values.company.siret} />
      {tunnelData.tenant === TENANTS.BPLS ? (
        <div>
          <Field
            hide={!company?.includes("executiveTitle")}
            name={"Executive title"}
            value={getCivilStatusLabel(tunnelData, values.company.executiveTitle)}
          />
          <Field
            hide={!company?.includes("executiveLastname")}
            name={"Executive lastname"}
            value={values.company.executiveLastname}
          />
          <Field
            hide={!company?.includes("executiveFirstname")}
            name={"Executive firstname"}
            value={values.company.executiveFirstname}
          />
        </div>
      ) : null}
      <Field
        hide={!company?.includes("executiveBirthdate")}
        name={"Executive birthdate"}
        value={values.company.executiveBirthdate}
      />
    </Bloc>
  )
}
